export const Fukusuke =
  'https://firebasestorage.googleapis.com/v0/b/fuurin-paint-workshop.appspot.com/o/sozai%2F%E7%A6%8F%E5%8A%A9%E4%BA%BA%E5%BD%A2%E3%81%AE%E3%83%95%E3%83%AA%E3%83%BC%E3%82%A4%E3%83%A9%E3%82%B9%E3%83%88.png?alt=media&token=760d55eb-e6f6-4eeb-8344-c18833c40b48';

export const MixColorPhoto =
  'https://firebasestorage.googleapis.com/v0/b/fuurin-paint-workshop.appspot.com/o/sozai%2Fcolor_description.jpg?alt=media&token=4db2d6cc-9bbe-4542-adab-4a2de5983d1c';

export const CautionPhoto =
  'https://firebasestorage.googleapis.com/v0/b/fuurin-paint-workshop.appspot.com/o/sozai%2Fcautionshot.jpg?alt=media&token=bfc59732-6433-4cc7-bd91-ed97cf73c6e3';

export const FuurinMakerPhoto =
  'https://firebasestorage.googleapis.com/v0/b/fuurin-paint-workshop.appspot.com/o/sozai%2Fhuurinmaker.jpg?alt=media&token=c0a9c7f5-08a8-4374-b646-ffc290446a68';

export const FuurinMakerCutPhoto =
  'https://firebasestorage.googleapis.com/v0/b/fuurin-paint-workshop.appspot.com/o/sozai%2Fhuurinmaker_you.jpg?alt=media&token=7fb0bd60-fbae-4356-81e2-bf23b6332b49';

export const CutTypePhoto =
  'https://firebasestorage.googleapis.com/v0/b/fuurin-paint-workshop.appspot.com/o/sozai%2Fhuurinmaker_kirinuki.jpg?alt=media&token=09d9e0cb-e20c-40b4-b122-fc28d9e65296';

export const CutProcessPhoto =
  'https://firebasestorage.googleapis.com/v0/b/fuurin-paint-workshop.appspot.com/o/sozai%2Fkirinuki.jpg?alt=media&token=d825d661-2039-4cb8-8290-8110acb04c44';

export const WorkshopPhoto =
  'https://firebasestorage.googleapis.com/v0/b/fuurin-paint-workshop.appspot.com/o/sozai%2FPainting%20Easter%20eggs-bro.png?alt=media&token=33960d85-90eb-4053-ad91-65a0c19756e9';

export const UploadPhoto =
  'https://firebasestorage.googleapis.com/v0/b/fuurin-paint-workshop.appspot.com/o/sozai%2FImage%20upload-amico.png?alt=media&token=e73531f1-adec-4e8b-9d9f-7c43e172f677';

export const EnjoyPhoto =
  'https://firebasestorage.googleapis.com/v0/b/fuurin-paint-workshop.appspot.com/o/sozai%2FMobile%20feed-amico.png?alt=media&token=dfb1eeb7-854b-452e-8b79-1cc6198461a2';

export const WorkshopKit =
  'https://firebasestorage.googleapis.com/v0/b/instagram-react-a7035.appspot.com/o/sozai%2Ftaiken_kit_contents.jpg?alt=media&token=dd683b38-f182-4e9e-9b20-affcaa163559';
